import { render, staticRenderFns } from "./searchGlobal.vue?vue&type=template&id=211dcc14&"
import script from "./searchGlobal.vue?vue&type=script&lang=js&"
export * from "./searchGlobal.vue?vue&type=script&lang=js&"
import style0 from "./searchGlobal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports